<template>

<div class="text" :class="{'is-center': isRegister}" v-html="item.text || item.content" />
	
</template>

<script>

export default {

	props: ['item'],

	computed: {

		isRegister: function() {

			return process.env.VUE_APP_TYPE === 'register'

		}

	}

}

</script>

<style scoped>

.is-mobile .text {
	padding: 0px 20px;
}

.text.is-center >>> * {
	text-align: center;
}

.text >>> h1 {
	font-size: 32px!important;
	line-height: 40px;
	font-weight: 700!important;
	margin-bottom: 20px;
	color: #343434!important;
}

.is-mobile .text >>> h1 {
	font-size: 20px!important;
    line-height: 24px!important;
}

.text >>> h2 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 500;
	margin-bottom: 20px;
	color: #343434;
}

.is-mobile .text >>> h2 {
	font-size: 18px!important;
    line-height: 22px!important;
}

.text >>> p {
	font-size: 16px!important;
	line-height: 20px!important;
	font-weight: 300!important;
	margin-bottom: 20px;
	color: #343434!important;
}

.is-mobile .text >>> p {
	font-size: 14px!important;
    line-height: 18px!important;
}

.text >>> a {
	color: #387DD8;
	font-weight: 700;
}

.text >>> a:hover {
	text-decoration: underline;
}

.text >>> *:last-child {
	margin-bottom: 0px;
}

.text >>> em,
.text >>> i {
	font-style: italic;
}

</style>